/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ exercise: NonNullable<unknown> }} Insight_PlateauInputs */

const en_us2_insight_plateau = /** @type {(inputs: Insight_PlateauInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} has stopped progressing. Time to swap it?`)
};

const pt_br2_insight_plateau = /** @type {(inputs: Insight_PlateauInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} parou de evoluir. Hora de trocar?`)
};

const es_419_insight_plateau = /** @type {(inputs: Insight_PlateauInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} dejó de progresar. ¿Hora de cambiarlo?`)
};

const pt_pt2_insight_plateau = /** @type {(inputs: Insight_PlateauInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} deixou de evoluir. Altura de trocar?`)
};

const fr_fr2_insight_plateau = /** @type {(inputs: Insight_PlateauInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} ne progresse plus. On le remplace ?`)
};

const de_de2_insight_plateau = /** @type {(inputs: Insight_PlateauInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} stagniert. Zeit für einen Wechsel?`)
};

const it_it2_insight_plateau = /** @type {(inputs: Insight_PlateauInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} ha smesso di progredire. È ora di cambiarlo?`)
};

/**
* | output |
* | --- |
* | "{exercise} has stopped progressing. Time to swap it?" |
*
* @param {Insight_PlateauInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const insight_plateau = /** @type {((inputs: Insight_PlateauInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insight_PlateauInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_insight_plateau(inputs)
	if (locale === "es-419") return es_419_insight_plateau(inputs)
	if (locale === "pt-PT") return pt_pt2_insight_plateau(inputs)
	if (locale === "fr-FR") return fr_fr2_insight_plateau(inputs)
	if (locale === "de-DE") return de_de2_insight_plateau(inputs)
	if (locale === "it-IT") return it_it2_insight_plateau(inputs)
	return en_us2_insight_plateau(inputs)
});
export { insight_plateau as "insight.plateau" }